export const SET_APP_VISIT = 'GlobalContext.SET_VISIT';
export const SET_EDITING_PAST_VISIT = 'GlobalContext.SET_EDITING_PAST_VISIT';
export const RESET_PRIOR_VISIT = 'GlobalContext.RESET_PRIOR_VISIT';
export const SET_LEVEL_OF_CARE = 'GlobalContext.SET_LEVEL_OF_CARE';
export const ADD_FORM = 'GlobalContext.ADD_FORM';
export const SET_FAJITA_FORM = 'GlobalContext.SET_FAJITA_FORM';
export const SET_FAJITA_WARNING = 'GlobalContext.SET_FAJITA_WARNING';
export const OPEN_WIDGET = 'GlobalContext.OPEN_WIDGET';
export const CLOSE_WIDGET = 'GlobalContext.CLOSE_WIDGET';
export const SET_WIDGET_NAMES_OPEN = 'GlobalContext.SET_WIDGET_NAMES_OPEN';
export const SET_GLOBAL_DOCTORS = 'GlobalContext.SET_GLOBAL_DOCTORS';
export const SET_MEDS = 'GlobalContext.SET_MEDS';
export const SET_GLOBAL_MEASURES = 'GlobalContext.SET_GLOBAL_MEASURES';
export const SET_PATIENT_SUBMITTED_CPP_LIST = 'GlobalContext.SET_PATIENT_SUBMITTED_CPP_LIST';
export const SET_GLOBAL_PATIENT = 'GlobalContext.SET_GLOBAL_PATIENT';
export const SET_CARE_PLAN_FREQUENCIES = 'GlobalContext.SET_CARE_PLAN_FREQUENCIES';
export const SET_PATIENT_DATE_RESTRICTIONS = 'GlobalContext.SET_PATIENT_DATE_RESTRICTIONS';
export const RESET_ADMIN_DATE_RESTRICTIONS = 'GlobalContext.RESET_ADMIN_DATE_RESTRICTIONS'; // DASHBOARD

export const RELOAD_MANIFEST = 'GlobalContext.RELOAD_MANIFEST';
export const RELOAD_MEASURES = 'GlobalContext.RELOAD_MEASURES';
export const REFRESH_GLOBAL_CONTEXT = 'GlobalContext.REFRESH_GLOBAL_CONTEXT';
export const SET_GENERAL_STANDING_ORDER = 'GlobalContext.SET_GENERAL_STANDING_ORDER';
export const SET_PATIENT_STANDING_ORDERS = 'GlobalContext.SET_PATIENT_STANDING_ORDERS';
export const REFRESH_PN_WIDGET = 'GlobalContext.REFRESH_PN_WIDGET'; // FORMS

export const SET_CROSS_PATIENT_WIP_FORMS = 'GlobalContext.SET_CROSS_PATIENT_WIP_FORMS';
export const SET_COMPLETED_FORMS = 'GlobalContext.SET_COMPLETED_FORMS';
export const SET_IN_PROGRESS_FORMS = 'GlobalContext.SET_IN_PROGRESS_FORMS';
export const SET_COMPLETED_HZ_FORMS = 'GlobalContext.SET_COMPLETED_HZ_FORMS';
export const SET_IN_PROGRESS_HZ_FORMS = 'GlobalContext.SET_IN_PROGRESS_HZ_FORMS';
export const SET_APP_VISIT_DETAILS = 'GlobalContext.SET_APP_VISIT_DETAILS'; // CPP and PATIENT_ASSISTANCE

export const SET_ATTEMPTED_VISIT_NOTE = 'GlobalContext.SET_ATTEMPTED_VISIT_NOTE'; // AG GRID COLUMN STATE

export const SET_AG_GRID_COLUMN_STATE = 'GlobalContext.SET_AG_GRID_COLUMN_STATE';
export const SET_AG_GRID_SELECTED_ROWS = 'GlobalContext.SET_AG_GRID_SELECTED_ROWS';
export const SET_FAX_LIST = 'GlobalContext.SET_FAX_LIST';
export const SET_EMAIL_LIST = 'GlobalContext.SET_EMAIL_LIST';
export const openVisit = 'openVisit';
export const priorVisit = 'priorVisit';
export const attemptedVisit = 'attemptedVisit';